import { useParams, useSearchParams } from "react-router-dom";
import { IncomeProvider } from "src/hooks/useData";
import { useEffect, useState } from "react";
import { getPrintClient } from "../services/client";
import Report from "../components/Report/Report";
import Footer from "src/components/Report/Footer";
import { ScenarioProvider } from "src/hooks/useScenario";
import { UserProvider } from "src/hooks/useUser";
import PrintReady from "src/components/PrintReady";

const PrintPage = () => {
  const [client, setClient] = useState(null as any);
  const { id, scenarioId } = useParams();
  const [searchParams, _] = useSearchParams();
  useEffect(() => {
    if (id)
      getPrintClient(id).then((data) => {
        setClient(data);
      });
  }, [id, scenarioId]);
  useEffect(() => {
    if (client?.userdata?.primaryColor) {
      document.documentElement.style.setProperty(
        "--primary-color",
        client.userdata.primaryColor,
      );
    }
  }, [client]);

  if (!client || !client.userdata) return <div>Loading...</div>;
  const scenario = client?.scenarios?.find((s: any) => s.id == scenarioId);
  const scenarioData = {
    ...scenario,
    people: client.people,
    mapType: client.liveSettings.mapType,
    inflationType: client.liveSettings.inflationType,
    monthlyYearly: client.liveSettings.monthlyYearly,
    chartType: client.liveSettings.chartType,
    maxYearsShown: client.liveSettings.maxYearsShown,
    taxType: client.liveSettings.taxType,
  };

  if (!scenarioData) return <div>Loading...</div>;
  const pages = JSON.parse(searchParams.get("page") || "[]");

  return (
    <UserProvider initialUser={{ info: client.userdata } as any}>
      <IncomeProvider data={client as any} setLocal={() => {}}>
        <ScenarioProvider scenario={scenarioData} client={client}>
          {pages.map((page: any) => (
            <div className="bg-white" key={page.name}>
              <Report client={client} scenario={scenarioData} page={page} />

              <Footer client={client} scenario={scenario} />
              <div className="break-after-page"></div>
            </div>
          ))}
          <PrintReady />
        </ScenarioProvider>
      </IncomeProvider>
    </UserProvider>
  );
};
export default PrintPage;
